import { fmtKst } from "../lib/format";
export default function ResourceNotice({ error, loading, receivedAt }: {
  error: string | null; loading: boolean; receivedAt: string | null;
}) {
  if (error) return <div className="notice-card" role="alert">조회 확인 필요: {error}
    {receivedAt && <p className="muted-note">마지막 성공 조회 {fmtKst(receivedAt)} KST · 이전 자료를 표시합니다.</p>}
  </div>;
  if (loading && !receivedAt) return <p className="muted-note" role="status">자료 조회 중…</p>;
  return null;
}
